'use client';

import { c as _c } from "react/compiler-runtime";
import { HeroUIProvider } from '@heroui/react';
export function HeroUIProviders(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <HeroUIProvider>{children}</HeroUIProvider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}